/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UtmSourceCount interface.
 */
export function instanceOfUtmSourceCount(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    return true;
}
export function UtmSourceCountFromJSON(json) {
    return UtmSourceCountFromJSONTyped(json, false);
}
export function UtmSourceCountFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'source': json['source'],
    };
}
export function UtmSourceCountToJSON(json) {
    return UtmSourceCountToJSONTyped(json, false);
}
export function UtmSourceCountToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'source': value['source'],
    };
}
